import './OrderItem.scss';
import React, { FC, useState } from 'react';
import Avatar from "../../atoms/Avatar/Avatar";
import Tag from "../../atoms/Tag/Tag";
import DeleteIcon from "../../icons/DeleteIcon";
import { getOrderStatus } from "../../../helpers/functions";
import { IOrder } from "../../../helpers/types";
import { Link } from "react-router-dom";

interface IOrderItem extends IOrder {
    isCheck?: boolean;
    status?: number;
    date?: string;
    unreadCount?: number;
    onSelect?: (checked: boolean) => void;
    isSelected?: boolean;
    isDelete?: boolean;
    onDelete?: () => void;
}

const OrderItem: FC<IOrderItem> = ({
                                       id,
                                       money_from,
                                       money_to,
                                       email,
                                        phone,
                                       tg_user,
                                       type_from,
                                       type_to,
                                       country,
                                       ip,
                                       status = 1,
                                       date,
                                       unreadCount = 0,
                                       isCheck = true,
                                       onSelect = () => {},
                                       isSelected = false,
                                       isDelete = false,
                                       onDelete = () => {}
                                   }) => {
    const [open, setOpen] = useState<boolean>(false)
    const changeOpen = () => {
        setOpen(!open)
    }

    const handleDelete = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onDelete();
    };

    const formattedMoneyFrom = parseFloat(Number(money_from).toFixed(2));
    const formattedMoneyTo = parseFloat(Number(money_to).toFixed(4));

    return (
        <div className={`order-item ${open ? "active" : ""}`}>
            <Link to={`/admin/orders/${id}`}>
                <div className="order-item__wrapper">
                    <div className="order-item__inner" onClick={changeOpen}>
                        <div className="order-item__id">ID: {id}</div>
                        <div className="order-item__avatar">
                            <Avatar name={tg_user ? tg_user : (email ? email: phone![0])} />
                            {unreadCount > 0 && (
                                <div className="order-item__unread-badge">{unreadCount}</div>
                            )}
                        </div>
                        <div className="order-item__name">{tg_user ? tg_user : (email ? email: phone)}</div>
                        <div className="order-item__money"><Tag name={`${formattedMoneyFrom} RUB`} color={"#1d65c2"} /> -&gt; <Tag name={`${formattedMoneyTo} ${type_to}`} color={"#104100"} /></div>
                        <div className="order-item__type-to"><Tag name={`${type_from}`} color={"#104100"} /> -&gt; <Tag name={`${type_to}`} color={"#1d65c2"} />  </div>
                        <div className="order-item__currency"><Tag name={`RUB`} color={"#1d65c2"} /> -&gt; <Tag name={`${type_to}`} color={"#104100"} /></div>
                        <div className="order-item__ip">IP: {ip}</div>
                        <div className="order-item__status"><Tag name={`${getOrderStatus(status).name}`} color={getOrderStatus(status).color} textColor={getOrderStatus(status).textColor} /></div>
                        <div className="order-item__date"><Tag name={`${date}`} color={"#104100"} /></div>
                        <div className="order-item__controls">
                            {isDelete && <a onClick={handleDelete}><DeleteIcon /></a>}
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};

export default OrderItem;